import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiRestService } from 'src/app/services/network/api-rest.service';

@Component({
    selector: 'app-content-layout',
    templateUrl: './content-layout.component.html',
    styleUrls: ['./content-layout.component.scss']
})

export class ContentLayoutComponent {

}